import Image from '@/src/components/CustomImage'
import useI18n from '@/src/hooks/use_i18n'
import RegisterForm from '../Form'

import styles from './index.module.scss'

export default function Section1({
  country,
  message,
  totalCarriersStr
}: {
  message: any
  country: string
  totalCarriersStr: string
}) {
  const { i18nFormat } = useI18n()
  return (
    <section className={styles.section1}>
      <Image src="/assets/images/api/Part1_bg.png" fill alt="section bg" />
      <div className={styles.container}>
        <div className={styles.row}>
          <div className={styles.pcPdLeft}>
            <h1>{message?.__internationalPackag}</h1>
            <h2 dangerouslySetInnerHTML={{ __html: message?.__accurateReliableUp }} />
            <div className={styles.headerDescription}>
              <p>
                {i18nFormat(message?.__accessTheTracking, [
                  <span className={styles.carrierBadge}>{totalCarriersStr}</span>
                ])}
              </p>
              <ul>
                <li>{message?.__forDevelopersAndD}</li>
                <li>{message?.__httpProtocalAllSy}</li>
                <li>{message?.__FreeTrial}</li>
              </ul>
            </div>
          </div>
          <div className={styles.pcPdRight}>
            <RegisterForm country={country} />
          </div>
        </div>
      </div>
    </section>
  )
}
